export const API_URL = 'https://msdgc.vieuxinc.com/api/vds/cincy/';



// WEBPACK FOOTER //
// ./src/lib/constants.js